/**
 * 即梦 5.0 Lite（doubao-seedream-5-0-260128）manifest
 * 数据来源：image.json field_map
 * 特点：2K/3K 两档清晰度，各档比例带真实像素；参考图约束最严（接口 field_map 明列）；
 *       提交前有生成图尺寸校验（转写自现有硬编码）
 */
import type { ImageModelConfig } from '../../types';

export const jimeng5Lite: ImageModelConfig = {
  id: '01KJVTK1Q8RXRNC9Y85XRTAG1P',
  displayName: '即梦 5.0 Lite',

  defaults: {
    ratio: '9:16', // 2K 档 select: true 项
    resolution: '2K', // 接口 resolution.default
  },

  ratioOptions: {
    '2K': [
      { label: '1:1', value: '1:1', width: 2048, height: 2048 },
      { label: '2:3', value: '2:3', width: 1664, height: 2496 },
      { label: '3:2', value: '3:2', width: 2496, height: 1664 },
      { label: '3:4', value: '3:4', width: 1728, height: 2304 },
      { label: '4:3', value: '4:3', width: 2304, height: 1728 },
      { label: '9:16', value: '9:16', width: 1440, height: 2560 },
      { label: '16:9', value: '16:9', width: 2560, height: 1440 },
      { label: '21:9', value: '21:9', width: 3024, height: 1296 },
    ],
    '3K': [
      { label: '1:1', value: '1:1', width: 3072, height: 3072 },
      { label: '2:3', value: '2:3', width: 2496, height: 3744 },
      { label: '3:2', value: '3:2', width: 3744, height: 2496 },
      { label: '3:4', value: '3:4', width: 2592, height: 3456 },
      { label: '4:3', value: '4:3', width: 3456, height: 2592 },
      { label: '9:16', value: '9:16', width: 2304, height: 4096 },
      { label: '16:9', value: '16:9', width: 4096, height: 2304 },
      { label: '21:9', value: '21:9', width: 4704, height: 2016 },
    ],
  },

  resolutionOptions: [
    { label: '高清 2K', value: '2K' },
    { label: '高清 3K', value: '3K' },
  ],
  resolutionLabel: '图片质量', // 接口 field_map.resolution.label

  qualityOptions: [],

  toggles: {},

  limits: {
    maxRefImages: 5, // 接口 field_map.ref_images.max
    // 参考图上传约束（全部来自接口 field_map.ref_images）
    refImageConstraints: {
      maxFileSizeMB: 30, // 单张大小上限（MB）
      dimension: { min: 15, max: 24000 }, // 宽、高像素范围
      aspectRatio: { min: 0.0625, max: 16 }, // 宽/高比例范围
      pixelCount: { min: 225, max: 36000000 }, // 总像素数（宽×高）范围
    },
    // 生成图尺寸校验（转写自 handleGenerate 现有硬编码：宽×高 ∈ [3686400, 10404496]、宽/高 ∈ [1/16, 16]）
    generationConstraints: {
      pixelCount: { min: 3686400, max: 10404496 },
      aspectRatio: { min: 1 / 16, max: 16 },
      pixelCountErrorKey: 'imageCreation.imageSizeInvalidJimeng', // 原即梦 5.0 Lite 专属文案
    },
  },
};
